<template>
    <el-date-picker
            v-bind="$attrs"
            :value="value"
            @input="onInput"
            type="datetime"
            :format="dateFormat"
            :value-format="formDateFormat"
            :picker-options="getOptions()"
    ></el-date-picker>
</template>

<script>
  export default {
    props: {
      value: null,
    },

    computed: {
      /**
       * @return {String}
       */
      dateFormat() {
        return config('format.element.short.datetime');
      },

      /**
       * @return {String}
       */
      formDateFormat() {
        return config('format.isoLocal');
      },
    },

    methods: {
      /**
       * @param {number} amount
       * @param {*} unit
       * @return {function}
       */
      getHandler(amount, unit) {
        return function (picker) {
          if (!picker.value) {
            return;
          }
          picker.$emit(
            'pick',
            moment(picker.value).add(amount, unit).toDate()
          );
        }
      },

      getOptions() {
        return {
          shortcuts: [
            {
              text: '+15 min',
              onClick: this.getHandler(15, 'minutes'),
            },
            {
              text: '+30 min',
              onClick: this.getHandler(30, 'minutes'),
            },
            {
              text: '+45 min',
              onClick: this.getHandler(45, 'minutes'),
            },
            {
              text: '+60 min',
              onClick: this.getHandler(60, 'minutes'),
            },
            {
              text: '+90 min',
              onClick: this.getHandler(90, 'minutes'),
            },
            {
              text: '+120 min',
              onClick: this.getHandler(120, 'minutes'),
            },
          ]
        };
      },

      onInput(val) {
        this.$emit('input', val);
      },
    },

  }
</script>
